// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"yq-z","breadcrumbForward":"zq-z","breadcrumbBack":"Aq-z","selected":"Bq-z"};